import OCGatewayClient from "../client/OCGatewayClient";
import { useMutation, useQuery } from "@tanstack/react-query";
import { Device } from "../models/Device";
import { User } from "../models/User";

export interface DeviceUserInviteDetails {
    inviteId: string;
    inviteToken: string;
    expiresAt: string;
    createdAt: string;
    device: Device;
    invitingUser: User;
}

export function useGetDeviceUserInviteQuery(inviteToken: string) {
    const query = useQuery({
        queryKey: ['getDeviceUserInvite', inviteToken],
        queryFn: async () => {
            return OCGatewayClient.request('getDeviceUserInvite', {
                inviteToken
            }) as Promise<DeviceUserInviteDetails>;
        },
        staleTime: 1000 * 60 * 5,
        gcTime: 1000 * 60 * 60 * 24,
        networkMode: 'always',
        retry: false
    });

    return query;
}

export interface DeviceUserInviteResult {
    inviteToken: string;
}

export function useCreateDeviceUserInviteMutation(deviceId: string) {
    const mutation = useMutation({
        mutationFn: async () => {
            return OCGatewayClient.request('createDeviceUserInvite', {
                deviceId
            }) as Promise<DeviceUserInviteResult>;
        }
    });

    return mutation;
}

export interface AcceptDeviceUserInviteResult {
    deviceId: string;
    success: boolean;
}

export function useAcceptDeviceUserInviteMutation() {
    const mutation = useMutation({
        mutationFn: async (inviteToken: string) => {
            return OCGatewayClient.request('acceptDeviceUserInvite', {
                inviteToken
            }) as Promise<AcceptDeviceUserInviteResult>;
        }
    });

    return mutation;
}
